/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	getChangeHistoryRequest,
	getChangeHistorySuccess,
	getChangeHistoryByEmRequest,
	getChangeHistoryByEmSuccess,
	getChangeHistoryByUserRequest,
	getChangeHistoryByUserSuccess,
	changeHistoryInitState,
} from './reducer';
import { TChangeHistoryRequest, TChangeHistoryResponsePayload } from './types';

export function* getChangeHistoryWorker(action: PayloadAction<TChangeHistoryRequest>) {
	const { payload } = action;
	try {
		const response: TChangeHistoryResponsePayload = yield call(
			api.changeHistory.getAuditLogs,
			payload,
		);
		yield put(getChangeHistorySuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(changeHistoryInitState());
	}
}

export function* getChangeHistoryByEmWorker(
	action: PayloadAction<{ id: number; body: TChangeHistoryRequest }>,
) {
	const { payload } = action;
	console.log('getChangeHistoryByEmWorkerpayload', payload);
	try {
		const response: TChangeHistoryResponsePayload = yield call(
			api.changeHistory.getAuditLogsByEm,
			payload,
		);
		yield put(getChangeHistoryByEmSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(changeHistoryInitState());
	}
}

export function* getChangeHistoryByUserWorker(
	action: PayloadAction<{ userId: number; body: TChangeHistoryRequest }>,
) {
	const { payload } = action;
	try {
		const response: TChangeHistoryResponsePayload = yield call(
			api.changeHistory.getAuditLogsByUser,
			payload,
		);
		yield put(getChangeHistoryByUserSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(changeHistoryInitState());
	}
}

export function* changeHistorySaga() {
	yield takeEvery(getChangeHistoryRequest.type, getChangeHistoryWorker);
	yield takeEvery(getChangeHistoryByEmRequest.type, getChangeHistoryByEmWorker);
	yield takeEvery(getChangeHistoryByUserRequest.type, getChangeHistoryByUserWorker);
}
